export const CheckBoxQcFieldName = 'checkBoxQcFieldComponent';
